import * as types from '@/store/mutation-types';
import _ from 'lodash';
import { searchParty } from '@/mixins/search-party';

const mutations = {
  [types.REARRANGE_SITE_MAP](state, p) {
    const siteMap = p.site.siteMap;
    const page = searchParty.methods._goFind({
      entry: siteMap,
      key: '_id',
      value: p.data.activeId,
    }).found;
    let newParent = searchParty.methods._goFind({
      entry: siteMap,
      key: '_id',
      value: p.data.activeNewParent,
    }).found;
    let oldParent = searchParty.methods._goFind({
      entry: siteMap,
      key: '_id',
      value: p.data.activeOldParent,
    }).found;

    // in the case where page is at the top level
    if (!newParent) {
      newParent = siteMap;
    } else {
      newParent = newParent.subPages;
    }

    if (!oldParent) {
      oldParent = siteMap;
    } else {
      oldParent = oldParent.subPages;
    }

    if (newParent === oldParent) {
      newParent.splice(p.data.newIndex, 0, newParent.splice(p.data.oldIndex, 1)[0]);
    } else {
      // remove from old parent
      oldParent.splice(p.data.oldIndex, 1);
      // add to new parent
      newParent.splice(p.data.newIndex, 0, page);
    }
  },
  [types.SET_SITE_MAP](state, p) {
    if (p.siteMap) {
      // used when resetting siteMap
      p.site.siteMap = p.siteMap;
    } else {
      // when we add new pages or update existing ones, we can use this to
      // update the sitemap as well so that they're always in sync

      // remove homepage from sitemap because we don't want its level to
      // be tampered with
      const pages = _.filter(p.site.pages, p => !p.isHomepage);
      _.forEach(pages, (page) => {
        const _id = page._id;
        // check if each page is in the site map.
        const smPage = searchParty.methods._goFind({
          entry: p.site.siteMap,
          key: '_id',
          value: _id,
        });
        // if page is not yet in the map, push into map array.
        if (!smPage.found) {
          p.site.siteMap.push({
            _id,
            name: page.name,
            url: page.url,
            subPages: [],
          });
        } else {
          // We need to update the page name anyway in case the page has been
          // edited since the last time this function ran... we might as well
          // use this loop to do it
          const existingPage = smPage.found;
          existingPage.name = page.name;
          existingPage.url = page.url;
        }
      });
    }
    this._vm.$log.debug('SET_SITE_MAP: ', p.site.siteMap);
  },
  [types.REMOVE_FROM_SITE_MAP](state, p) {
    const _id = p.page._id;
    // check if each page is in the site map.
    const pg = searchParty.methods._goFind({
      entry: p.site.siteMap,
      key: '_id',
      value: _id,
    });
    this._vm.$log.debug('REMOVE_FROM_SITE_MAP: ', pg);
    pg.parentArray.splice(pg.index, 1);
  },
  [types.ADD_TO_SITE_MAP](state, p) {
    p.site.siteMap.push({
      _id: p.page._id,
      name: p.page.name,
      url: p.page.url,
      subPages: [],
    });
    this._vm.$log.debug('ADD_TO_SITE_MAP', p.site.siteMap);
  },
};

const actions = {
  setSiteMap: ({ commit, rootState }, data) => {
    const payload = {
      site: rootState.Websites.currentSite,
      siteMap: data,
    };
    return new Promise((resolve) => {
      commit(types.SET_SITE_MAP, payload);
      resolve();
    });
  },
  rearrangeSiteMap: ({ commit, dispatch, rootState }, payload) => {
    // Get references to the pieces we need to manipulate
    const p = {
      site: rootState.Websites.currentSite,
      data: payload,
    };
    commit(types.REARRANGE_SITE_MAP, p);
    const sitemap = p.site.siteMap;
    dispatch('updatePageLinks', { sitemap });
  },
  removeFromSiteMap: ({ commit, rootState }, page) => {
    const payload = {
      site: rootState.Websites.currentSite,
      page,
    };
    return new Promise((resolve) => {
      commit(types.REMOVE_FROM_SITE_MAP, payload);
      resolve();
    });
  },
  addToSiteMap: ({ commit, rootState }, page) => {
    const payload = {
      site: rootState.Websites.currentSite,
      page,
    };
    return new Promise((resolve) => {
      commit(types.ADD_TO_SITE_MAP, payload);
      resolve();
    });
  },
};

export default {
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/global-view/editor/page/top-control-bar/global-options/site-map/vuex.js